import { Link } from "react-router-dom";
import { ArrowRight, Store, Handshake } from "lucide-react";

export const DEALER_SEO_LINKS = [
  { name: "How to open a Total Wireless store", path: "/how-to-open-a-total-wireless-store", icon: Store },
  { name: "Become a Total Wireless dealer", path: "/become-dealer", icon: Handshake },
];
export const DEALER_EXTRA_LINKS = [
  { name: "Ready-to-go stores", path: "/ready-to-go-stores" },
  { name: "Upcoming stores", path: "/upcoming-stores" },
];

// Shown above the footer on every public page (search phrases + dealer call to action)
export const DealerCtaStrip = () => (
  <section className="bg-teal" data-testid="dealer-cta-strip" aria-label="Dealer opportunities">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row md:items-center gap-3 md:gap-8">
      <p className="text-white/80 text-xs uppercase tracking-[0.2em] font-semibold font-body shrink-0">Dealer opportunities</p>
      <div className="flex flex-col sm:flex-row gap-3 sm:gap-8 flex-1">
        {DEALER_SEO_LINKS.map(({ name, path, icon: Icon }) => (
          <Link key={path} to={path} data-testid={`dealer-cta-${path.slice(1)}`}
            className="group inline-flex items-center gap-2 text-white font-heading font-semibold text-base sm:text-lg hover:text-navy transition-colors">
            <Icon className="w-5 h-5 shrink-0" />
            <span>{name}</span>
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </Link>
        ))}
      </div>
    </div>
  </section>
);
